import { IBroadcastChatData } from "@home-health-notify/domain";
import { List } from "@mui/material";
import { useTranslation } from "hhn-commons";
import EmptyRecordView from "../../../common/EmptyRecordView";
import GoToTop from "../../../common/GoToTop";
import ScrollListContainer from "../../../common/ScrollListContainer";
import { useScrollAnchor } from "../../../hooks/useScrollAnchor";
import ProgressLoader from "../../../loader/ProgressLoader";
import BroadcastChatListItem from "./BroadcastChatListItem";

type BroadcastChatListProps = {
  chats: IBroadcastChatData[];
  selectedChatId?: string;
  isChatLoading: boolean;
  fetchChatList: () => Promise<void>;
};

const BroadcastChatList = ({
  chats,
  selectedChatId,
  isChatLoading,
  fetchChatList,
}: BroadcastChatListProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });

  const { scrollContainerRef, isShowGoToTopButton, goToTop } = useScrollAnchor({
    items: chats,
    getItemId: chat => chat.id,
    getItemVersion: chat => chat.updatedAt,
    selectedItemId: selectedChatId,
  });

  return (
    <>
      <ScrollListContainer
        ref={scrollContainerRef}
        onScrollCallback={fetchChatList}
        isLoading={isChatLoading}
        dataTestId="  broadcastChatList"
        restTop={isChatLoading ? 202 : 114}
      >
        <>
          {isShowGoToTopButton && <GoToTop onClick={goToTop} />}
          {chats.length > 0 && (
            <List data-testid="chatList" sx={{ paddingTop: "0px" }}>
              {chats.map((chatData: IBroadcastChatData) => (
                <BroadcastChatListItem
                  key={chatData.id}
                  chatData={chatData}
                  isSelected={selectedChatId === chatData.id}
                />
              ))}
            </List>
          )}
          {!isChatLoading && chats.length === 0 && <EmptyRecordView />}
          {isChatLoading && (
            <ProgressLoader
              label={tNs("chatLoadingMessage")}
              style={{
                height: "auto",
              }}
            />
          )}
        </>
      </ScrollListContainer>
    </>
  );
};

export default BroadcastChatList;
//dummy code line
